export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_04.5335e01a.jpg";